import React from 'react';

import { type Edition } from '../../restapi/types';
import { EditionSummary } from '../home/EditionSummary';


interface Props {
	edition: Edition;
}

export function LeftPanel({edition}: Props) {
	return (
		<div style={{width: 300}}>
			<EditionSummary notInHome def={edition.type} edition={edition}/>
		</div>
	);
}